import classNames from 'classnames/bind';
import { DateFormat } from 'common/types';
import { Days, days } from 'common/utils';
import useFarePrices from 'hooks/useFarePrices';
import useHolidays from 'hooks/useHolidays';
import { useCallback, useState } from 'react';
import { useInfiniteSeveral } from 'react-awesome-calendar-ts';
import DateInput from './dateInput';
import styles from './index.module.scss';
import RemoveSelectedDates from './removeSelectedDates';
import { ICalendar } from './types';

const cx = classNames.bind(styles);

const OneWayCalendar = ({
  searchParams,
  setDepartureDate,
  closeModal,
  isDomestic,
}: ICalendar) => {
  const { itinerary, tripType } = searchParams;
  const Calendar = useInfiniteSeveral();
  const [selectedDate, setSelectedDate] = useState(
    itinerary?.[0]?.departureDate
      ? days(itinerary[0].departureDate, DateFormat.YMD)
      : null,
  );
  const [viewMonths, onViewMonthsUpdated] = useState<Days[]>([]);
  const holidays = useHolidays(viewMonths);
  const customDates = useFarePrices(searchParams, isDomestic, viewMonths[0]);
  const clearSelectedDates = useCallback(() => {
    setDepartureDate();
    setSelectedDate(null);
  }, []);

  const onSuccess = useCallback(
    (dates: (Days | null)[]) => {
      if (!dates || !dates[0]) {
        setDepartureDate();
        return;
      }
      setSelectedDate(dates[0]);
      setDepartureDate(dates[0]);
      closeModal();
    },
    [itinerary],
  );

  return (
    <div className={cx('calendar')}>
      <div className={cx('schedules')}>
        <div className={cx('inner')}>
          <DateInput
            buttonTitles={['가는 날']}
            clickCode="cal.depdate1"
            cx={cx}
            dateInfo={selectedDate}
            editing={!!selectedDate}
            index={0}
            onSelect={() => {}}
          />
        </div>
      </div>
      <div
        className={cx('content')}
        data-event-nlog="click"
        data-event-area-code="cal.calendar"
      >
        <Calendar
          options={{
            dateFormat: DateFormat.YMD,
            dayTexts: ['일', '월', '화', '수', '목', '금', '토'],
            todayText: '오늘',
            selectionTextBuilder: () => '선택',
            maxSelection: 1,
            maxMonths: 12,
            cancelable: true,
            height: '100%',
            visibleMonthCount: 14,
            todaySelectable: isDomestic,
          }}
          mutableOptions={{
            selectedDates: selectedDate ? [selectedDate] : [],
            holidays,
            customDates,
          }}
          methods={{
            onViewMonthsUpdated,
            onSuccess,
          }}
        />
      </div>
      <RemoveSelectedDates
        clearSelectedDates={clearSelectedDates}
        tripType={tripType}
      />
    </div>
  );
};

export default OneWayCalendar;
